export class CriminalGridAcceptanceDisclaimer {
    id: number;
    clientId: number;
    userId: number;
}